<template>
   <div class=" wrapper">
    <section class="grid-content">
      <div class="contenedor">
        <form @submit.prevent="updateOwner()">
          <div>
            <div class="form-group">
              <label for="exampleInputEmail1">{{ $t('ResetPassEmail') }}</label>
              <input
                v-model="user.email"
                type="email"
                class="form-control"
                id="exampleInputEmail1"
                aria-describedby="emailHelp"
                :placeholder="email"
              >
            </div>
            <div class="form-group">
              <label for="exampleInputPassword1">{{ $t('ResetPassOld') }}</label>
              <input
                v-model="user.password"             
                type="password"
                class="form-control"
                id="exampleInputPassword1"
                :placeholder="$t('PlaceholderResetPassOld')"
                @change="checkIsUserRegisteredandExist()">
              <small v-if="isErrorLogin" class="error">{{$t('userUpdateUncorrectLogin')}}</small>
              <small v-if="isCheckedLogin" class="correct">{{$t('userUpdateCorrectLogin')}}</small>     
            </div>
             <div class="form-group" v-if="isCheckedLogin">
            <label for="exampleInputPassword1">{{ $t('ResetPassNew') }}</label>
            <input
              v-model="user.newpassword"             
              type="password"
              class="form-control"
              id="exampleInputPassword1"
              :placeholder="$t('PlaceholderResetPassNew')">
          </div>
          <div class="form-group" v-if="isCheckedLogin">
            <label for="exampleInputPassword1">{{ $t('ResetPassNewConfirm') }}</label>
            <input
              v-model="user.confirmnewpassword"             
              type="password"
              class="form-control"
              id="exampleInputPassword1"
              :placeholder="$t('PlaceholderResetPassNewConfirm')"
              @change="checkPasswordEquals()">
              <small v-if="isErrorPass" class="error">{{$t('userUpdateUncorrectConfirmPass')}}</small>
              <small v-if="isCheckedPass" class="correct">{{$t('userUpdateCorrectConfirmPass')}}</small>
          </div>
            <div class="form-group">
              <label for="exampleInputName1">{{ $t('ResetPassName') }}</label>
              <input
                v-model="user.firstname"
                type="text"
                class="form-control"
                id="exampleInputName1"
                aria-describedby="nameHelp"
                :placeholder=owner.firstname
                @change="checkFormInputs()"
                :disabled="!isCheckedLogin"
              >
            </div>
            <div class="form-group">
              <label for="exampleInputLastname1">{{ $t('ResetPassSurname') }}</label>
              <input
                v-model="user.lastname"
                type="text"
                class="form-control"
                id="exampleInputLastname1"
                aria-describedby="surnameHelp"
                :placeholder=owner.lastname
                @change="checkFormInputs()"
                :disabled="!isCheckedLogin"
              >
            </div>
            <div class="form-group">
              <label for="exampleInputPhone1">{{ $t('ResetPassPhone') }}</label>
              <input
                v-model="user.phone"
                type="tel"
                class="form-control"
                id="exampleInputPhone1"
                aria-describedby="phoneHelp"
                :placeholder=owner.phone
                @change="checkFormInputs()"
                :disabled="!isCheckedLogin"
              >
            </div>
            
          </div>                                
            <button type="submit" class="btn btn-primary" :disabled="!isCheckedLogin">{{ $t('userUpdateButton') }} <img v-if="!isCheckedLogin" src="https://shots.jotform.com/jan/images/lock-icon.png" alt="Locker Image"> </button>
        </form>
      </div>
    </section>  
  </div>
</template>

<script>
  import i18n from '@/plugins/i18n';

  export default {
    data() {
      return {
        isErrorLogin:false,
        isCheckedLogin:false,
        isErrorPass:false,
        isCheckedPass:false,
        isUpdate:false,
        isLogged:localStorage.getItem("is_logged"),
        email:localStorage.getItem("user_email"),
        user:{
          firstname:"",
          lastname:"",
          phone:"",
          email:"",
          password:"",
          newpassword:"",
          confirmnewpassword:"",
          role:""
        },
        owner:{},
        languages: [{ 
                      flag: 'us', 
                      language: 'en', 
                      title: 'English' 
                    },
                    { flag: 'es', 
                      language: 'es', 
                      title: 'Español' },
                    { flag: 'de',
                      language: 'de',
                      title: 'Deutsch'}]
      };
    },
    methods: {
      checkIsUserRegisteredandExist(event) {
        console.log("Comprobación de acceso, Actualizada la pagina");
        console.log("El usuario es el siguiente: ",this.user);
        this.axios.post('https://lightkey.es:3000/lightkey/api/users/auth',{email: this.user.email, password:this.user.password})
        .then(response => {
              if (response.data && this.isLogged) {
                //Si está
                this.isCheckedLogin = true;
                this.isErrorLogin = false;
                //this.newKey.email = response.data.email;
                console.log("Está correcto");
              }
          //localStorage.setItem("session", JSON.stringify(response.data));
          //this.$toastr.s("Login correcto");
          //this.$router.replace('/dashboard');
        })
        .catch(err => {
          console.log("Algo pasa!");                
          console.log("Login erroneo", err);
          this.isCheckedLogin = false;
          this.isErrorLogin = true;
          console.log("No está correcto");
          err => console.log(err);
          //this.$toastr.e("Login incorrecto");
        });
      },
      checkPasswordEquals(){ 
        if(this.user.newpassword===this.user.confirmnewpassword){
            this.isCheckedPass = true;
            this.isErrorPass = false;
            this.isUpdate=true;
            this.user.password=this.user.newpassword;
        }else{
            this.isCheckedPass = false;
            this.isErrorPass = true;
            this.isUpdate=false;
            this.user.password=this.owner.password;
        }
      },
      checkFormInputs(){
        console.log("user\n",this.user);
        //Comprobación de los campos del owner
        if(this.user.email || this.user.firstname || this.user.lastname || this.user.phone){
          //Si hay algún cambio en el email o contraseña nueva o cambio de nombre o apellidos
          if((this.user.email!=this.email) || (this.isCheckedPass) || (this.user.firstname!=this.owner.firstname) || (this.user.lastname!=this.owner.lastname) || (this.user.phone!=this.owner.phone)){
            this.isUpdate=true;
            return true;
          }else{
            this.isUpdate=false;
            return false;
          }
        }
        return true;
      },
      updateOwner(){
        if(this.checkFormInputs()){
          var login = JSON.parse(localStorage.getItem("session"));
          //this.user.password=this.user.newpassword;
          this.axios.put('https://lightkey.es:3000/lightkey/api/owner/update',{data : this.user},{headers: { authorization: login.session }})
          .then(response=> {
            switch(i18n.locale){
                case "en":
                    this.$toastr.s(i18n.messages.en.ownerUpdate);
                    break;
                case "es":
                    this.$toastr.s(i18n.messages.es.ownerUpdate);
                    break;
                case "de":
                    this.$toastr.s(i18n.messages.de.ownerUpdate);
                    break;  
            }
            this.$router.replace('/dashboard/view-users');
          })
          .catch(error=>{console.log(error.response);
            switch(i18n.locale){
                case "en":
                    this.$toastr.e(i18n.messages.en.ownerNotUpdate);
                    break;
                case "es":
                    this.$toastr.e(i18n.messages.es.ownerNotUpdate);
                    break;
                case "de":
                    this.$toastr.e(i18n.messages.de.ownerNotUpdate);
                    break;  
            }            
          })
        }
      },
      getOwnerByEmail(){
        if(this.isLogged){
          var login = JSON.parse(localStorage.getItem("session"));
          console.log(this.email);
          if(!this.user.email){
            this.user.email=this.email;
          }
          this.axios.post('https://lightkey.es:3000/lightkey/api/owner',{email: this.email},{headers: { authorization: login.session }})
          .then(response => {
              this.owner=response.data;
              this.user.firstname=this.owner.firstname;
              this.user.lastname=this.owner.lastname;
              this.user.phone=this.owner.phone;
              this.user.role=this.owner.authorities[0].authority;
              this.user.id=this.owner.id;
              console.log("owner:\n",this.owner);
            })
          .catch(error=>console.log(error))
        }
      }
    },
    created(){
      this.getOwnerByEmail();
    }
  };
</script>

<style>
.contenedor {
  padding: 10% 30px;
  /*border: 2px solid #4cae4c;
  border-radius: 20px;*/
}

.logo {
  margin-right: 38px;
  padding: 40px;
}

.logo-img {
  max-width: 200px;
}

.logo-text {
  max-width: 150px;
}

h1 {
  color: #7ab648;
}

.forgot--btn {
  text-decoration: none;
  color: #353d46;
}
.forgot--btn:hover {
  color: #7ab648;
}


a.signup--btn  {
  color:white;
}

.btn {
  background-color: #5cb85c;
  color: white;
  border: 1px solid #4cae4c;
}

.wrapper {
  /* padding: 50px auto; */
  display: grid;
  grid-template-columns: 1fr minmax(200px, 700px) 1fr;
}

@media only screen and (max-width: 430px) {
  .wrapper {
    /* padding: 50px auto; */
    display: grid;
    grid-template-columns: 1fr minmax(200px, 300px) 1fr;
  }
}

.grid-content {
  grid-column: 2/3;
}

.error {
  color: red;
}

.correct {
  color: green;
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/children/Update.vue